import { CardButton } from 'presentation/components/molecules/Card'
import { FailedInvoiceSummary } from 'presentation/main/globalModals/FailedInvoiceModal/FailedInvoiceModal.types'
import { closeModal, goBackModal } from 'presentation/main/globalModals/globalModals.utils'
import { openErrorModal } from 'presentation/screens/Billing/Billing.modals'

export const CHOOSE_PLAN_PATH = '/pricing#first-choose-plan'

export const hasLegacyPastDueInvoice = ({
  failedInvoiceSummary,
  isLegacyPlan,
}: {
  failedInvoiceSummary?: FailedInvoiceSummary
  isLegacyPlan?: boolean | null
}): boolean => !!failedInvoiceSummary && !!isLegacyPlan

export const shouldChooseNewPlanForLapsedLegacySubscription = ({
  hasCancellationPassed,
  failedInvoiceSummary,
  isInactive,
  isLegacyPlan,
}: {
  hasCancellationPassed: boolean
  failedInvoiceSummary?: FailedInvoiceSummary
  isInactive: boolean
  isLegacyPlan?: boolean | null
}): boolean =>
  // Only explicitly retired plans are blocked here. Hidden/custom plans that
  // are still valid should continue through the normal restore/payment flow.
  !!isLegacyPlan
  && (isInactive || !!failedInvoiceSummary || hasCancellationPassed)

export const redirectToChoosePlan = (): void => {
  closeModal()

  if (typeof window !== 'undefined')
    window.location.assign(CHOOSE_PLAN_PATH)
}

export const openLegacyPastDuePlanErrorModal = (): void => {
  openErrorModal({
    title: 'Your previous plan is no longer available',
    message: 'That plan has been retired. Choose a current plan to continue your subscription.',
    actionButtons: () => (
      <>
        <CardButton
          variant='outline'
          colorScheme='neutral'
          onClick={goBackModal}
        >
          Cancel
        </CardButton>
        <CardButton
          variant='solid'
          colorScheme='positive'
          onClick={redirectToChoosePlan}
          autoFocus
        >
          Choose Plan
        </CardButton>
      </>
    ),
  })
}
